import axios from 'axios'
import { saveAs } from 'file-saver'
import { arrayBufferToBlob } from 'blob-util'

export default {
  // получить тест
  getTest(courseId, testId) {
    return axios.get(`/api/education/courses/${courseId}/tests/${testId}`)
  },
  // удалить тест
  deleteTest(courseId, testId) {
    return axios.delete(`/api/education/courses/${courseId}/tests/${testId}`)
  },
  // обновить настройки теста
  updateTestSettings(courseId, testId, newSettings) {
    return axios.put(`/api/education/courses/${courseId}/tests/${testId}`, newSettings)
  },
  // обновить вопросы в тесте
  updateTestQuestions(courseId, testId, questionsIds) {
    return axios.put(`/api/education/courses/${courseId}/tests/${testId}/content`, questionsIds)
  },
  // получить список отчетов по тесту
  // получить список приглашенных на тест
  getTestProgress(testId, classes, organizationId) {
    const params = {
      classes
    }
    if (organizationId) {
      params.organizationId = organizationId
    }
    return axios.get(`/api/education/courses/test/${testId}/students/report`, { params })
  },
  // отправить приглашения на тест
  sendTestInvitations(testId, students) {
    return axios.post(`/api/education/courses/test/${testId}/students`, { students })
  },
  // получить вопросы для создания теста
  getContentForTest(courseId) {
    return axios.get(`/api/education/courses/${courseId}/content`, {
      params: { all: true, test: true }
    })
  },
  // создать новый тест
  makeNewTest(courseId, isCreatedByTeacher) {
    return axios.post(`/api/education/courses/${courseId}/tests`, { isCreatedByTeacher: Boolean(isCreatedByTeacher) })
  },
  // запуск теста
  startTest(courseId, testId) {
    return axios.post(`/api/education/courses/${courseId}/tests/${testId}/start`)
  },
  // отправить ответы на тест
  sendTestAnswers(courseId, testId, test) {
    return axios.put(`/api/education/courses/${courseId}/tests/${testId}/progress`, { test })
  },

  sendSCORMTestResults(courseId, scoreRaw) {
    return axios.put('/api/education/scorm-result', {
      courseId,
      scoreRaw
    })
  },

  // изменить оценку ученику
  updateStudentMark(testId, userId, mark) {
    return axios.put(`/api/education/courses/tests/${testId}/students/${userId}`, { mark })
  },
  shuffle(a) { // Тасование Fisher-Yates
    for (let i = a.length - 1; i > 0; i--) { // eslint-disable-line no-plusplus
      const j = Math.floor(Math.random() * (i + 1))
      // [a[i], a[j]] = [a[j], a[i]]
      const t = a[i]
      a[i] = a[j] // eslint-disable-line no-param-reassign
      a[j] = t // eslint-disable-line no-param-reassign
    }
    return a
  },
  // сброс настроек теста
  restTestsettings(courseId, testId) {
    return axios.put(`/api/education/courses/${courseId}/tests/${testId}/reset`)
  },
  exportTestResultsExcel(testId, classes, organizationId) {
    const query = {
      responseType: 'arraybuffer',
      params: {
        classes
      }
    }
    if (organizationId) {
      query.params.organizationId = organizationId
    }
    return axios.get(`/api/education/courses/test/${testId}/students/report/xlsx`, query)
      .then(
        (response) => {
          saveAs(arrayBufferToBlob(response.data),
            response.headers['content-disposition']
              .replace('attachment; filename=', ''))
        },
        (error) => {
          console.log(error)
        },
      )
  }
}
